import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Self-hosted variable fonts (spec §3.10.1): no third-party font request, and the Inter
// package ships the latin-ext subset that carries the rupee sign (U+20B9).
import '@fontsource-variable/inter'
import '@fontsource-variable/jetbrains-mono'
import './index.css'
import App from './App'
import { ToastProvider } from '@/hooks/useToast'
import { UpdatePrompt } from '@/components/layout/UpdatePrompt'
import { registerServiceWorker } from '@/lib/registerSw'
import { isNativeApp } from '@/mobile/platform'

registerServiceWorker(isNativeApp())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <App />
      <UpdatePrompt />
    </ToastProvider>
  </StrictMode>,
)
